var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"clock"},[_vm._v(_vm._s(_vm.clock))])]),_c('DeparturesTable',{attrs:{"panelConfig":_vm.panelConfig,"stopData":_vm.stopData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }